import academyRouterPaths from './academyRouterPaths';

export default academyRouterPaths;
